.section {
  background: #fff;
  color: var(--yo-ink);
}
.inner {
  max-width: 1328px;
  margin-inline: auto;
  padding: 44px 24px 28px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 24px;
  margin-bottom: 26px;
}
.kicker {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 10px;
  font: 600 10px var(--font-en);
  letter-spacing: 0.12em;
}
.kicker::before {
  content: "";
  width: 8px;
  height: 8px;
  background: var(--yo-yellow);
}
.heading {
  margin: 0;
  font-size: clamp(26px, 2.8vw, 38px);
  font-weight: 800;
  letter-spacing: -0.045em;
  line-height: 1.4;
}
.intro {
  margin: 0 0 3px;
  color: #65645f;
  font-size: 12px;
  line-height: 1.9;
}
.masonry {
  columns: 6;
  column-gap: 14px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.tile {
  break-inside: avoid;
  margin-bottom: 16px;
}
.photo {
  display: block;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--yo-ink);
  text-align: left;
  cursor: zoom-in;
}
.photo:focus-visible {
  outline: 3px solid var(--yo-blue);
  outline-offset: 4px;
  border-radius: var(--yo-radius);
}
.imageFrame {
  position: relative;
  display: block;
  overflow: hidden;
  border-radius: var(--yo-radius);
  background: #eeede8;
}
.image {
  display: block;
  width: 100%;
  height: auto;
  transition:
    transform 0.4s cubic-bezier(0.2, 0.7, 0.2, 1),
    filter 0.2s;
}
.caption {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 9px 4px 0;
}
.category {
  color: #767570;
  font: 500 8px var(--font-en);
  letter-spacing: 0.08em;
}
.workTitle {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
}
.zoomHint {
  position: absolute;
  top: 10px;
  right: 10px;
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: var(--yo-radius);
  background: #fff;
  color: #171714;
  opacity: 0;
  transform: translateY(4px);
  transition:
    opacity 0.2s,
    transform 0.2s;
}
.photo:focus-visible .zoomHint {
  opacity: 1;
  transform: none;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
}
.allWorks,
.inquiry {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.inquiry {
  color: #65645f;
  font-weight: 500;
}
.allWorks:focus-visible,
.inquiry:focus-visible,
.close:focus-visible,
.modalInquiry:focus-visible {
  outline: 3px solid var(--yo-blue);
  outline-offset: 4px;
}
.dialog {
  width: min(1160px, 94vw);
  max-width: none;
  max-height: 92svh;
  margin: auto;
  padding: 0;
  border: 0;
  background: #fff;
  color: var(--yo-ink);
  overflow-y: auto;
}
.dialog[open] {
  animation: photo-open 0.2s ease-out;
}
.dialog::backdrop {
  background: #141512d9;
}
.lightbox {
  padding: 20px;
}
.close {
  position: absolute;
  top: 28px;
  right: 28px;
  z-index: 2;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: var(--yo-radius);
  background: #fff;
  color: #151515;
  box-shadow: 0 2px 12px #0002;
  cursor: pointer;
}
.largeImage {
  position: relative;
  height: min(70svh, 760px);
}
.contain {
  object-fit: contain;
}
.modalCaption {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 8px 0;
  font-size: 13px;
}
.modalCaption p {
  margin: 0;
  font-weight: 600;
}
.modalInquiry {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  font-size: 12px;
}
@keyframes photo-open {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@media (hover: hover) {
  .photo:hover .image {
    transform: scale(1.025);
    filter: brightness(0.9);
  }
  .photo:hover .zoomHint {
    opacity: 1;
    transform: none;
  }
  .allWorks:hover,
  .inquiry:hover,
  .modalInquiry:hover {
    text-decoration: underline;
    text-underline-offset: 5px;
  }
}
@media (min-width: 768px) and (max-width: 1199px) {
  .masonry {
    columns: 4;
  }
}
@media (max-width: 767px) {
  .inner {
    padding: 28px 16px 20px;
  }
  .header {
    display: block;
    margin-bottom: 18px;
  }
  .kicker {
    margin-bottom: 8px;
    font-size: 9px;
  }
  .heading {
    font-size: clamp(24px, 6.4vw, 32px);
  }
  .intro {
    margin-top: 8px;
    font-size: 11px;
  }
  .intro br {
    display: none;
  }
  .masonry {
    columns: 2;
    column-gap: 12px;
  }
  .tile {
    margin-bottom: 16px;
  }
  .imageFrame {
    border-radius: var(--yo-radius);
  }
  .caption {
    gap: 3px;
    padding: 8px 3px 0;
  }
  .category {
    font-size: 7px;
  }
  .workTitle {
    font-size: 11px;
  }
  .footer {
    margin-top: 8px;
  }
  .inquiry,
  .allWorks {
    gap: 5px;
    font-size: 11px;
  }
  .lightbox {
    padding: 10px;
  }
  .close {
    top: 18px;
    right: 18px;
  }
  .largeImage {
    height: 60svh;
  }
}
@media (prefers-reduced-motion: reduce) {
  .image,
  .zoomHint {
    transition: none;
  }
  .dialog[open] {
    animation: none;
  }
  .photo:hover .image {
    transform: none;
  }
}
